export const agreementApiPath = {
  getTermsAgreements: '/v2/curator/terms/agreements',
  postTermsAgreements: '/v2/curator/terms/agreements',
} as const;
